/**
 * Full TeaserTileBlock fragment — King Living override.
 *
 * Base generated fragment includes both teaserTilesCollection and teaserTilesCursorCollection,
 * each with full TeaserTileFragment, which roughly doubles GraphQL complexity. The storefront
 * only uses teaserTilesCollection (see teaser-tile-block.jsx). Omitting the cursor collection
 * keeps GetFullTeaserTileBlockById under Contentful complexity limits (TOO_COMPLEX_QUERY).
 */

import gql from 'graphql-tag';

import {BaseTeaserTileBlockFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile-block/base-teaser-tile-block.fragment';
import {TeaserTileFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile/teaser-tile.fragment';

export const FullTeaserTileBlockFragment = gql`
  ${BaseTeaserTileBlockFragment}
  ${TeaserTileFragment}

  fragment FullTeaserTileBlockFragment on TeaserTileBlock {
    ...BaseTeaserTileBlockFragment

    teaserTilesCollection(limit: 24) {
      items {
        __typename
        ... on TeaserTile {
          ...TeaserTileFragment
        }
      }
    }
  }
`;
